/*!
 * AppleDB device names, MIT License.
 * Source: https://api.appledb.dev/device/main.json
 * Revision: 90134cb81b2dc60306b1bb694081e8e5692398f6 (2026-10-25).
 * Public Apple Watch, iPhone, iPad families, and iPod touch only; internal records excluded.
 *
 * MIT License
 *
 * Copyright (c) 2022 emiyl
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const APPLE_DEVICE_CATALOG: Readonly<Record<string, string>> = {
  "iPad1,1": "iPad",
  "iPad11,1": "iPad mini (5th generation) Wi-Fi",
  "iPad11,2": "iPad mini (5th generation) Wi-Fi + Cellular",
  "iPad11,3": "iPad Air (3rd generation) Wi-Fi",
  "iPad11,4": "iPad Air (3rd generation) Wi-Fi + Cellular",
  "iPad11,6": "iPad (8th generation) Wi-Fi",
  "iPad11,7": "iPad (8th generation) Wi-Fi + Cellular",
  "iPad12,1": "iPad (9th generation) Wi-Fi",
  "iPad12,2": "iPad (9th generation) Wi-Fi + Cellular",
  "iPad13,1": "iPad Air (4th generation) Wi-Fi",
  "iPad13,10": "iPad Pro 12.9-inch (5th generation) Wi-Fi + Cellular",
  "iPad13,11": "iPad Pro 12.9-inch (5th generation) Wi-Fi + Cellular (1 or 2 TB)",
  "iPad13,16": "iPad Air (5th generation) Wi-Fi",
  "iPad13,17": "iPad Air (5th generation) Wi-Fi + Cellular",
  "iPad13,18": "iPad (10th generation) Wi-Fi",
  "iPad13,19": "iPad (10th generation) Wi-Fi + Cellular",
  "iPad13,2": "iPad Air (4th generation) Wi-Fi + Cellular",
  "iPad13,4": "iPad Pro 11-inch (3rd generation) Wi-Fi",
  "iPad13,5": "iPad Pro 11-inch (3rd generation) Wi-Fi (1 or 2 TB)",
  "iPad13,6": "iPad Pro 11-inch (3rd generation) Wi-Fi + Cellular",
  "iPad13,7": "iPad Pro 11-inch (3rd generation) Wi-Fi + Cellular (1 or 2 TB)",
  "iPad13,8": "iPad Pro 12.9-inch (5th generation) Wi-Fi",
  "iPad13,9": "iPad Pro 12.9-inch (5th generation) Wi-Fi (1 or 2 TB)",
  "iPad14,1": "iPad mini (6th generation) Wi-Fi",
  "iPad14,10": "iPad Air 13-inch (M2) Wi-Fi",
  "iPad14,11": "iPad Air 13-inch (M2) Wi-Fi + Cellular",
  "iPad14,2": "iPad mini (6th generation) Wi-Fi + Cellular",
  "iPad14,3": "iPad Pro 11-inch (4th generation) Wi-Fi",
  "iPad14,4": "iPad Pro 11-inch (4th generation) Wi-Fi + Cellular",
  "iPad14,5": "iPad Pro 12.9-inch (6th generation) Wi-Fi",
  "iPad14,6": "iPad Pro 12.9-inch (6th generation) Wi-Fi + Cellular",
  "iPad14,8": "iPad Air 11-inch (M2) Wi-Fi",
  "iPad14,9": "iPad Air 11-inch (M2) Wi-Fi + Cellular",
  "iPad15,3": "iPad Air 11-inch (M3) Wi-Fi",
  "iPad15,4": "iPad Air 11-inch (M3) Wi-Fi + Cellular",
  "iPad15,5": "iPad Air 13-inch (M3) Wi-Fi",
  "iPad15,6": "iPad Air 13-inch (M3) Wi-Fi + Cellular",
  "iPad15,7": "iPad (A16) Wi-Fi",
  "iPad15,8": "iPad (A16) Wi-Fi + Cellular",
  "iPad16,1": "iPad mini (A17 Pro) Wi-Fi",
  "iPad16,10": "iPad Air 13-inch (M4) Wi-Fi",
  "iPad16,11": "iPad Air 13-inch (M4) Wi-Fi + Cellular",
  "iPad16,2": "iPad mini (A17 Pro) Wi-Fi + Cellular",
  "iPad16,3": "iPad Pro 11-inch (M4) Wi-Fi",
  "iPad16,4": "iPad Pro 11-inch (M4) Wi-Fi + Cellular",
  "iPad16,5": "iPad Pro 13-inch (M4) Wi-Fi",
  "iPad16,6": "iPad Pro 13-inch (M4) Wi-Fi + Cellular",
  "iPad16,8": "iPad Air 11-inch (M4) Wi-Fi",
  "iPad16,9": "iPad Air 11-inch (M4) Wi-Fi + Cellular",
  "iPad17,1": "iPad Pro 11-inch Wi-Fi (M5)",
  "iPad17,2": "iPad Pro 11-inch Wi-Fi + Cellular (M5)",
  "iPad17,3": "iPad Pro 13-inch Wi-Fi (M5)",
  "iPad17,4": "iPad Pro 13-inch Wi-Fi + Cellular (M5)",
  "iPad2,1": "iPad 2 Wi-Fi",
  "iPad2,2": "iPad 2 Wi-Fi + 3G (GSM)",
  "iPad2,3": "iPad 2 Wi-Fi + 3G (CDMA)",
  "iPad2,4": "iPad 2 Wi-Fi (Mid 2012)",
  "iPad2,5": "iPad mini Wi-Fi",
  "iPad2,6": "iPad mini Wi-Fi + Cellular",
  "iPad2,7": "iPad mini Wi-Fi + Cellular (MM)",
  "iPad3,1": "iPad (3rd generation) Wi-Fi",
  "iPad3,2": "iPad (3rd generation) Wi-Fi + Cellular (VZ)",
  "iPad3,3": "iPad (3rd generation) Wi-Fi + Cellular",
  "iPad3,4": "iPad (4th generation) Wi-Fi",
  "iPad3,5": "iPad (4th generation) Wi-Fi + Cellular",
  "iPad3,6": "iPad (4th generation) Wi-Fi + Cellular (MM)",
  "iPad4,1": "iPad Air Wi-Fi",
  "iPad4,2": "iPad Air Wi-Fi + Cellular",
  "iPad4,3": "iPad Air Wi-Fi + Cellular (TD-LTE)",
  "iPad4,4": "iPad mini 2 Wi-Fi",
  "iPad4,5": "iPad mini 2 Wi-Fi + Cellular",
  "iPad4,6": "iPad mini 2 Wi-Fi + Cellular (TD-LTE)",
  "iPad4,7": "iPad mini 3 Wi-Fi",
  "iPad4,8": "iPad mini 3 Wi-Fi + Cellular",
  "iPad4,9": "iPad mini 3 Wi-Fi + Cellular (TD-LTE)",
  "iPad5,1": "iPad mini 4 Wi-Fi",
  "iPad5,2": "iPad mini 4 Wi-Fi + Cellular",
  "iPad5,3": "iPad Air 2 Wi-Fi",
  "iPad5,4": "iPad Air 2 Wi-Fi + Cellular",
  "iPad6,11": "iPad (5th generation) Wi-Fi",
  "iPad6,12": "iPad (5th generation) Wi-Fi + Cellular",
  "iPad6,3": "iPad Pro (9.7-inch) Wi-Fi",
  "iPad6,4": "iPad Pro (9.7-inch) Wi-Fi + Cellular",
  "iPad6,7": "iPad Pro (12.9-inch) (1st generation) Wi-Fi",
  "iPad6,8": "iPad Pro (12.9-inch) (1st generation) Wi-Fi + Cellular",
  "iPad7,1": "iPad Pro (12.9-inch) (2nd generation) Wi-Fi",
  "iPad7,11": "iPad (7th generation) Wi-Fi",
  "iPad7,12": "iPad (7th generation) Wi-Fi + Cellular",
  "iPad7,2": "iPad Pro (12.9-inch) (2nd generation) Wi-Fi + Cellular",
  "iPad7,3": "iPad Pro (10.5-inch) Wi-Fi",
  "iPad7,4": "iPad Pro (10.5-inch) Wi-Fi + Cellular",
  "iPad7,5": "iPad (6th generation) Wi-Fi",
  "iPad7,6": "iPad (6th generation) Wi-Fi + Cellular",
  "iPad8,1": "iPad Pro 11-inch (1st generation) Wi-Fi",
  "iPad8,10": "iPad Pro 11-inch (2nd generation) Wi-Fi + Cellular",
  "iPad8,11": "iPad Pro 12.9-inch (4th generation) Wi-Fi",
  "iPad8,12": "iPad Pro 12.9-inch (4th generation) Wi-Fi + Cellular",
  "iPad8,2": "iPad Pro 11-inch (1st generation) Wi-Fi (1TB)",
  "iPad8,3": "iPad Pro 11-inch (1st generation) Wi-Fi + Cellular",
  "iPad8,4": "iPad Pro 11-inch (1st generation) Wi-Fi + Cellular (1TB)",
  "iPad8,5": "iPad Pro 12.9-inch (3rd generation) Wi-Fi",
  "iPad8,6": "iPad Pro 12.9-inch (3rd generation) Wi-Fi (1TB)",
  "iPad8,7": "iPad Pro 12.9-inch (3rd generation) Wi-Fi + Cellular",
  "iPad8,8": "iPad Pro 12.9-inch (3rd generation) Wi-Fi + Cellular (1TB)",
  "iPad8,9": "iPad Pro 11-inch (2nd generation) Wi-Fi",
  "iPhone1,1": "iPhone",
  "iPhone1,2": "iPhone 3G",
  "iPhone10,1": "iPhone 8 (CDMA)",
  "iPhone10,2": "iPhone 8 Plus (CDMA)",
  "iPhone10,3": "iPhone X (CDMA)",
  "iPhone10,4": "iPhone 8 (GSM)",
  "iPhone10,5": "iPhone 8 Plus (GSM)",
  "iPhone10,6": "iPhone X (GSM)",
  "iPhone11,2": "iPhone XS",
  "iPhone11,4": "iPhone XS Max (China mainland)",
  "iPhone11,6": "iPhone XS Max",
  "iPhone11,8": "iPhone XR",
  "iPhone12,1": "iPhone 11",
  "iPhone12,3": "iPhone 11 Pro",
  "iPhone12,5": "iPhone 11 Pro Max",
  "iPhone12,8": "iPhone SE (2nd generation)",
  "iPhone13,1": "iPhone 12 mini",
  "iPhone13,2": "iPhone 12",
  "iPhone13,3": "iPhone 12 Pro",
  "iPhone13,4": "iPhone 12 Pro Max",
  "iPhone14,2": "iPhone 13 Pro",
  "iPhone14,3": "iPhone 13 Pro Max",
  "iPhone14,4": "iPhone 13 mini",
  "iPhone14,5": "iPhone 13",
  "iPhone14,6": "iPhone SE (3rd generation)",
  "iPhone14,7": "iPhone 14",
  "iPhone14,8": "iPhone 14 Plus",
  "iPhone15,2": "iPhone 14 Pro",
  "iPhone15,3": "iPhone 14 Pro Max",
  "iPhone15,4": "iPhone 15",
  "iPhone15,5": "iPhone 15 Plus",
  "iPhone16,1": "iPhone 15 Pro",
  "iPhone16,2": "iPhone 15 Pro Max",
  "iPhone17,1": "iPhone 16 Pro",
  "iPhone17,2": "iPhone 16 Pro Max",
  "iPhone17,3": "iPhone 16",
  "iPhone17,4": "iPhone 16 Plus",
  "iPhone17,5": "iPhone 16e",
  "iPhone18,1": "iPhone 17 Pro",
  "iPhone18,2": "iPhone 17 Pro Max",
  "iPhone18,3": "iPhone 17",
  "iPhone18,4": "iPhone Air",
  "iPhone18,5": "iPhone 17e",
  "iPhone19,2": "iPhone 18 Pro",
  "iPhone19,3": "iPhone 18 Pro Max (US)",
  "iPhone19,4": "iPhone Duo",
  "iPhone19,7": "iPhone 18 Pro Max (Global)",
  "iPhone2,1": "iPhone 3GS",
  "iPhone3,1": "iPhone 4 (GSM)",
  "iPhone3,2": "iPhone 4 (GSM, 2012)",
  "iPhone3,3": "iPhone 4 (CDMA)",
  "iPhone4,1": "iPhone 4S",
  "iPhone5,1": "iPhone 5 (GSM)",
  "iPhone5,2": "iPhone 5 (CDMA)",
  "iPhone5,3": "iPhone 5c (GSM)",
  "iPhone5,4": "iPhone 5c (CDMA)",
  "iPhone6,1": "iPhone 5s (GSM)",
  "iPhone6,2": "iPhone 5s (CDMA)",
  "iPhone7,1": "iPhone 6 Plus",
  "iPhone7,2": "iPhone 6",
  "iPhone8,1": "iPhone 6s",
  "iPhone8,2": "iPhone 6s Plus",
  "iPhone8,4": "iPhone SE (1st generation)",
  "iPhone9,1": "iPhone 7 (CDMA)",
  "iPhone9,2": "iPhone 7 Plus (CDMA)",
  "iPhone9,3": "iPhone 7 (GSM)",
  "iPhone9,4": "iPhone 7 Plus (GSM)",
  "iPod1,1": "iPod touch (1st generation)",
  "iPod2,1": "iPod touch (2nd generation)",
  "iPod3,1": "iPod touch (3rd generation)",
  "iPod4,1": "iPod touch (4th generation)",
  "iPod5,1": "iPod touch (5th generation)",
  "iPod7,1": "iPod touch (6th generation)",
  "iPod9,1": "iPod touch (7th generation)",
  "Watch1,1": "Apple Watch (1st generation) (38mm)",
  "Watch1,2": "Apple Watch (1st generation) (42mm)",
  "Watch2,3": "Apple Watch Series 2 (38mm)",
  "Watch2,4": "Apple Watch Series 2 (42mm)",
  "Watch2,6": "Apple Watch Series 1 (38mm)",
  "Watch2,7": "Apple Watch Series 1 (42mm)",
  "Watch3,1": "Apple Watch Series 3 (GPS + Cellular, 38mm)",
  "Watch3,2": "Apple Watch Series 3 (GPS + Cellular, 42mm)",
  "Watch3,3": "Apple Watch Series 3 (GPS, 38mm)",
  "Watch3,4": "Apple Watch Series 3 (GPS, 42mm)",
  "Watch4,1": "Apple Watch Series 4 (GPS, 40mm)",
  "Watch4,2": "Apple Watch Series 4 (GPS, 44mm)",
  "Watch4,3": "Apple Watch Series 4 (GPS + Cellular, 40mm)",
  "Watch4,4": "Apple Watch Series 4 (GPS + Cellular, 44mm)",
  "Watch5,1": "Apple Watch Series 5 (GPS, 40mm)",
  "Watch5,10": "Apple Watch SE (1st generation, GPS, 44mm)",
  // Correct upstream size typo: A2353/A2355 are 40mm. https://support.apple.com/en-us/108056
  "Watch5,11": "Apple Watch SE (1st generation, GPS + Cellular, 40mm)",
  "Watch5,12": "Apple Watch SE (1st generation, GPS + Cellular, 44mm)",
  "Watch5,2": "Apple Watch Series 5 (GPS, 44mm)",
  "Watch5,3": "Apple Watch Series 5 (GPS + Cellular, 40mm)",
  "Watch5,4": "Apple Watch Series 5 (GPS + Cellular, 44mm)",
  "Watch5,9": "Apple Watch SE (1st generation, GPS, 40mm)",
  "Watch6,1": "Apple Watch Series 6 (GPS, 40mm)",
  "Watch6,10": "Apple Watch SE (2nd generation, GPS, 40mm)",
  "Watch6,11": "Apple Watch SE (2nd generation, GPS, 44mm)",
  "Watch6,12": "Apple Watch SE (2nd generation, GPS + Cellular, 40mm)",
  "Watch6,13": "Apple Watch SE (2nd generation, GPS + Cellular, 44mm)",
  "Watch6,14": "Apple Watch Series 8 (GPS, 41mm)",
  "Watch6,15": "Apple Watch Series 8 (GPS, 45mm)",
  "Watch6,16": "Apple Watch Series 8 (GPS + Cellular, 41mm)",
  "Watch6,17": "Apple Watch Series 8 (GPS + Cellular, 45mm)",
  "Watch6,18": "Apple Watch Ultra",
  "Watch6,2": "Apple Watch Series 6 (GPS, 44mm)",
  "Watch6,3": "Apple Watch Series 6 (GPS + Cellular, 40mm)",
  "Watch6,4": "Apple Watch Series 6 (GPS + Cellular, 44mm)",
  "Watch6,6": "Apple Watch Series 7 (GPS, 41mm)",
  "Watch6,7": "Apple Watch Series 7 (GPS, 45mm)",
  "Watch6,8": "Apple Watch Series 7 (GPS + Cellular, 41mm)",
  "Watch6,9": "Apple Watch Series 7 (GPS + Cellular, 45mm)",
  "Watch7,1": "Apple Watch Series 9 (GPS, 41mm)",
  "Watch7,10": "Apple Watch Series 10 (GPS + Cellular, 42mm)",
  "Watch7,11": "Apple Watch Series 10 (GPS + Cellular, 46mm)",
  "Watch7,12": "Apple Watch Ultra 3",
  "Watch7,13": "Apple Watch SE 3 (GPS, 40mm)",
  "Watch7,14": "Apple Watch SE 3 (GPS, 44mm)",
  "Watch7,15": "Apple Watch SE 3 (GPS + Cellular, 40mm)",
  "Watch7,16": "Apple Watch SE 3 (GPS + Cellular, 44mm)",
  "Watch7,17": "Apple Watch Series 11 (GPS, 42mm)",
  "Watch7,18": "Apple Watch Series 11 (GPS, 46mm)",
  "Watch7,19": "Apple Watch Series 11 (GPS + Cellular, 42mm)",
  "Watch7,2": "Apple Watch Series 9 (GPS, 45mm)",
  "Watch7,20": "Apple Watch Series 11 (GPS + Cellular, 46mm)",
  "Watch7,3": "Apple Watch Series 9 (GPS + Cellular, 41mm)",
  "Watch7,4": "Apple Watch Series 9 (GPS + Cellular, 45mm)",
  "Watch7,5": "Apple Watch Ultra 2",
  "Watch7,8": "Apple Watch Series 10 (GPS, 42mm)",
  "Watch7,9": "Apple Watch Series 10 (GPS, 46mm)",
  "Watch8,1": "Apple Watch Ultra 4",
  "Watch8,2": "Apple Watch Series 12 (GPS, 42mm)",
  "Watch8,3": "Apple Watch Series 12 (GPS, 46mm)",
  "Watch8,4": "Apple Watch Series 12 (GPS + Cellular, 42mm)",
  "Watch8,5": "Apple Watch Series 12 (GPS + Cellular, 46mm)",
};

export default APPLE_DEVICE_CATALOG;
